import { WebVttTransformer } from './WebVttTransformer.js';
/**
 * WebVTT transform stream.
 *
 * @group WebVTT
 *
 * @beta
 */
export class WebVttTransformStream extends TransformStream {
    constructor(writableStrategy, readableStrategy) {
        super(new WebVttTransformer(), writableStrategy, readableStrategy);
    }
}
//# sourceMappingURL=WebVttTransformStream.js.map